<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import { getVersion } from '@/api/commont'
  export default {
    name: 'App',
    data(){
      return {}
    },
    mounted() {
      getVersion().then(({ data }) => {
        if(data.code === 0){
          console.log('%c V_API：'+data.data.version, 'color:red;')
          console.log('%c V_WEB：'+process.env.VUE_APP_VERSION, 'color:red;')
        }
        
      })
    }
  }

</script>
<style lang="scss">
#app {
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

</style>
